import { createContext } from "react";

const AmountContext = createContext();

export default AmountContext;
